import { render } from "./DFormsTest.vue?vue&type=template&id=3d3117b2"
import script from "./DFormsTest.vue?vue&type=script&lang=ts"
export * from "./DFormsTest.vue?vue&type=script&lang=ts"
script.render = render

export default script